@if (currency==='BGN') {
  <div class="payment-form">
    @if (recievedSelectedPaymentType == 12) {
      <span>Вашата месечна вноска ще бъде:</span>
    }
    @if (recievedSelectedPaymentType == 1) {
      <span>Вашата годишна вноска ще бъде:</span>
    }
    <br>
      <span class="payment-form-sum">{{payment}} ЛВ</span>
      <div class="smaller-details">От които {{initManPrem | number: '1.0-2'}} ЛВ по основното покритие и {{payment-initManPrem | number: '1.0-2'}} ЛВ за избраните от Вас рискове</div>
    </div>
  }
  @if (currency==='EUR') {
    <div class="payment-form">
      @if (recievedSelectedPaymentType == 12) {
        <span>Вашата месечна вноска ще бъде:</span>
      }
      @if (recievedSelectedPaymentType == 1) {
        <span>Вашата годишна вноска ще бъде:</span>
      }
      <br>
        <span class="payment-form-sum">{{payment}} ЕВРО</span>
        <div class="smaller-details">От които {{initManPrem | number: '1.0-2'}} ЕВРО по основното покритие и {{payment-initManPrem | number: '1.0-2'}} ЕВРО за избраните от Вас рискове</div>
      </div>
    }
    <div class="payment-form-button-details-container">
      <div class="payment-form-button-container">
        <div class="payment-form-buttons-grid">
          <div class="payment-form-button-1-area">
            <button class="payment-form-change-button-1" (click)="changeChosenPackage()">ПРОМЕНИ ПАКЕТ</button>
          </div>
          <div class="payment-form-button-area">
            <button type="button" class="payment-form-button" (click)="expandPaymentForm()">
              <span class="payment-form-button-text"> ВИЖ ДЕТАЙЛИ ЗА СВОЯТА ЗАЩИТА </span>
              @if (!isPaymentFormButtonClicked) {
                <span>
                  <nx-icon name="chevron-right" class="white" size="s" aria-hidden="true"></nx-icon>
                </span>
              }
              @if (isPaymentFormButtonClicked) {
                <span>
                  <nx-icon name="chevron-down" size="s" class="white" aria-hidden="true"></nx-icon>
                </span>
              }
            </button>
          </div>
          <div class="payment-form-button-2-area">
            <button class="payment-form-change-button-2" type="button" (click)="calculateAgain()">ИЗЧИСЛИ ОТНОВО</button>
          </div>
        </div>
      </div>
    </div>
    @if (isPaymentFormButtonClicked) {
      <div class="payment-form-button-container-extended-part">
        @if (currency === 'BGN') {
          <div class="font-weight-700 details-sum">{{recievedAmoutOfMoney}} ЛВ финансова защита</div>
        } @else {
          <div class="font-weight-700 details-sum">{{recievedAmoutOfMoney}} ЕВРО финансова защита</div>
        }
        <div class="margin-25">по <br> основното покритие: смърт на застрахованото лице, настъпила през срока на застраховката.
        </div>
        <div class="margin-25">При изтичане срока на полицата и редовно платени вноски Вие ще получите:
          <div class="font-weight-700">30% от размера на платената премия по основното покритие:</div>
          @if (currency === 'BGN') {
            <div class="font-weight-700 details-sum">{{initManPrem*recievedSelectedPaymentType*recievedYears*0.3 | number: '1.0-2'}} ЛВ</div>
          } @else {
            <div class="font-weight-700 details-sum">{{initManPrem*recievedSelectedPaymentType*recievedYears*0.3 | number: '1.0-2'}} ЕВРО</div>
          }
        </div>
        <div class="normal-light-blue-heading">Избрахте да се защитите в следните случаи: </div>
        @if (isDeathByAccidentIncluded) {
          <div class="margin-25">
            <img src="./assets/person_heart.png" class="details-img"><br>
            При смърт в резултат на злополука, ползващите лица получават
            @if (currency === 'BGN') {
              <div class="font-weight-700">{{moneyByDeath}} ЛВ</div>
            } @else {
              <div class="font-weight-700">{{moneyByDeath}} ЕВРО</div>
            }
          </div>
        }
        @if (isLongTermLossOfEmploymentByAccidentIncluded) {
          <div class="margin-25">
            <img src="./assets/chair.png" class="details-img"><br>
            При трайно намалена трудоспособност над 70% при злополука ще получите
            <div class="font-weight-700">% от застрахователната сума</div>
          </div>
        }
        @if (isLongTermLossOfEmploymentByDiseaseIncluded) {
          <div class="margin-25">
            <img src="./assets/chair.png" class="details-img"><br>
            При трайно намалена трудоспособност над 70% при злополука и/или заболяване ще получите
            <div class="font-weight-700">% от застрахователната сума</div>
          </div>
        }
        @if (isTemporraryLossOfEmploymentByAccidentIncluded) {
          <div class="margin-25">
            @if (currency === 'BGN') {
              <div class="font-weight-700 details-sum">200 <br>ЛВ</div>
            } @else {
              <div class="font-weight-700 details-sum">100 <br>ЕВРО</div>
            }
            Седмично обезщетение при временна загуба на трудоспособност в резултат на злополука
          </div>
        }
        @if (isTemporraryLossOfEmploymentByDiseaseIncluded) {
          <div class="margin-25">
            @if (currency === 'BGN') {
              <div class="font-weight-700 details-sum">200 <br>ЛВ</div>
            } @else {
              <div class="font-weight-700 details-sum">100 <br>ЕВРО</div>
            }
            Седмично обезщетение при временна загуба на трудоспособност в резултат на злополука и/или заболяване
          </div>
        }
        @if (isStayAtHospitalByAccidentIncluded) {
          <div class="margin-25">
            @if (currency === 'BGN') {
              <div class="font-weight-700 details-sum">100 <br>ЛВ</div>
            } @else {
              <div class="font-weight-700 details-sum">50 <br>ЕВРО</div>
            }
            Дневно обезщетение при болничен престой при злополука
          </div>
        }
        @if (isStayAtHospitalByDiseaseIncluded) {
          <div class="margin-25">
            @if (currency === 'BGN') {
              <div class="font-weight-700 details-sum">100 <br>ЛВ</div>
            } @else {
              <div class="font-weight-700 details-sum">50 <br>ЕВРО</div>
            }
            Дневно обезщетение при болничен престой при злополука и/или заболяване
          </div>
        }
        @if (isExpenditureForMedicinesByAccidentIncluded) {
          <div class="margin-25">
            @if (currency === 'BGN') {
              <div class="font-weight-700 details-sum">50/100 <br>ЛВ</div>
            } @else {
              <div class="font-weight-700">25/50 <br>ЕВРО</div>
            }
            Обезщетение при извършен лекарски преглед в резултат на злополука
            <div class="font-weight-700 details-sum">при преглед от специалист/при преглед от хабилитирано лице</div>
          </div>
        }
        @if (isExpenditureForMedicinesByDiseaseIncluded) {
          <div class="margin-25">
            @if (currency === 'BGN') {
              <div class="font-weight-700 details-sum">50/100 <br>ЛВ</div>
            } @else {
              <div class="font-weight-700 details-sum">25/50 <br>ЕВРО</div>
            }
            Обезщетение при извършен лекарски преглед в резултат на злополука и/или заболяване
            <div class="font-weight-700">при преглед от специалист/при преглед от хабилитирано лице</div>
          </div>
        }
        @if (isCrillIncluded) {
          <div class="margin-25">
            <img src="./assets/bag.png" class="details-img"><br>
            При тежки заболявания ще ви бъдат изплатени
            @if (currency === 'BGN') {
              <div class="font-weight-700">{{moneyByCrill}} ЛВ </div>
            } @else {
              <div class="font-weight-700">{{moneyByCrill}} ЕВРО </div>
            }
          </div>
        }
        @if (isSecondMedicalOpinionIncluded) {
          <div class="margin-25">
            <img src="./assets/heart.png" class="details-img"><br>
            Включено второ медицинско мнение
          </div>
        }
        <div class="margin-top-25">
          <div class="font-weight-700">Забележка: </div>
          <i>Резултатите за Вашата програма са изчислени при стандартен застрахователен риск и при редовно плащане на Вашата вноска.</i>
        </div>
      </div>
    }